import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Popover, Switch } from "@headlessui/react";
import React from "react";
import { useTranslation } from "react-i18next";

interface Props {
  consentKey: string;
  value: boolean;
  disabled?: boolean;
  onChange: (v: boolean) => void
}

const ConsentSwitch: React.FC<Props> = ({
  consentKey: key, value, disabled, onChange,
}) => {
  const { t } = useTranslation("member");
  // eslint-disable-next-line no-nested-ternary
  const color = disabled ? "bg-blue-300" : (value ? "bg-blue-600" : "bg-gray-200");

  return (
    <Switch.Group>
      <div className="flex justify-between">
        <div className="flex ml-1">
          <Popover className="relative">
            <Popover.Button><FontAwesomeIcon icon={faCircleInfo} className="mr-2" /></Popover.Button>
            <Popover.Panel className="absolute z-10 w-80">
              <div className="text-sm bg-slate-900 text-white py-3 px-6 rounded-lg">{t(`common:${key}Help`)}</div>
            </Popover.Panel>
          </Popover>
          <Switch.Label className="mr-4">
            {t(`common:${key}`)}
          </Switch.Label>
        </div>
        <div className="justify-self-end">
          <Switch
            data-pw={key}
            disabled={disabled}
            checked={value}
            onChange={onChange}
            className={`${color} relative inline-flex h-6 w-11 items-center rounded-full transition-colors`}
          >
            <span
              className={`${
                value ? "translate-x-6" : "translate-x-1"
              } inline-block h-4 w-4 transform rounded-full bg-white transition-transform`}
            />
          </Switch>
        </div>
      </div>
    </Switch.Group>
  );
};

export default ConsentSwitch;
